<template>
    <div>
        <div v-if="isClientAccount" class="mb-3 text-right">
            <b-button variant="success" @click="openClientOrderForm">
                Создать заявку
            </b-button>
        </div>
        <tsoft-table
            :name="'order'"
            :api="tableApiUrlChooser()"
            :items.sync="items"
            :isNeedSearch="externalCall() ? false : true"
            :isNeedCreate="(isLeadObserver || externalCall()) ? false : true"
            :isNeedSelection="(isClientAccount || isAgent || isLeadObserver) ? false : true"
            :headerContextMenuName="headerContextMenuName"
            @show="showItem"
            @edit="createOrEditItemModal"
            @delete="deleteItem"
            @copy="copyItem"
            @score="scoreItem"
            @createOrderBillFromAction="createOrderBillFromAction"
            @createOrderFinanceRequestFromAction="createOrderFinanceRequestFromAction"
            @openOrderDocumentsFromAction="openOrderDocumentsFromAction"
            @makeOrderSupply="makeOrderSupply"
            @openServiceDistributionModal="openServiceDistributionModal"
            @openScoreSidebar="openScoreSidebar"
            :key="tableComponentRefreshKey"
            :onDataEmptyMessage="onDataEmptyMessage"
            :typeOfTableFilter="externalCall() ? '' : typeOfTableFilter"
            :customAddButtonName="'Создать заявку'"
            :additionalGetParameter="additionalGetParameter()"
            :needFilter="needFilter"
            :specificApiRequest="specificApiRequest"
        ></tsoft-table>

        <b-sidebar
            v-if="isSidebarOpenDetail"
            v-model="isSidebarOpenDetail"
            id="sidebar-right"
            right
            backdrop
            shadow
            width="109em"
            backdrop-variant="dark"
            no-close-on-backdrop
            lazy
        >
            <template #title>
                <div class="title-sidebar">
                    <button
                        class="btn btn-outline-blue"
                        @click="openCreateTaskSidebar"
                    >Создать задачу</button>
                    <strong class="ml-4">Детальная информация</strong>
                </div>
            </template>
            <tsoft-order-show-one
                :detailedItemIndex="detailedItemIndex"
                :detailedItem="detailedItem"
                @closeOrder="closeOrderByIndex"
                @changeOrderStatus="changeOrderStatusByID"
                @changeCreatorUserId="changeCreatorUserId"
                @updateOneOrder="updateOneOrder"
            ></tsoft-order-show-one>
            <b-overlay
                :show="dataOverlay"
                spinner-variant="success"
                no-wrap
            ></b-overlay>
        </b-sidebar>

        <OrderScoreSidebar
            :isSidebarOpenScore="isSidebarOpenScore"
            :scoreText="''"
            :tempScoreOrderId="tempScoreOrderId"
            :stars="0"
            @update:isSidebarOpenScore="value => isSidebarOpenScore = value"
            @closeScoreSidebar="closeScoreSidebar"
            @saveOrderScore="saveOrderScore"
        />

        <tsoft-create-company
            :isSideBarOpenCompany.sync='isSideBarOpenCompany'
            :editIndex.sync="editIndex"
            :editedItem.sync="editedItem"
            @create='setCreatedCompany'
            @closeSidePanel='setClosedSidePanelCompany'
        />

        <tsoft-order-service-distribution
            :isOpenServiceDistributionModal.sync="isOpenServiceDistributionModal"
            :editIndex="editIndex"
            :editedItem="editedItem"
            @updateOneOrder="updateOneOrder"
        ></tsoft-order-service-distribution>

        <tsoft-order-scoring
            :openScoreBoxIndex="openScoreBoxIndex"
            :openScoreBoxItemId="openScoreBoxItemId"
            :scoringItemClose="scoringItemClose"
        ></tsoft-order-scoring>

        <b-modal
            id="order-documents-help-modal"
            title="Памятка по документам при оформлении заказа"
            v-model="openHelp"
            hide-footer
        >
            <p><em>Список документов дан максимально исчерпывающий, не все из перечисленных документов обязательны для оформления услуг:</em></p>
            <p><strong>Для заявок ТЭО:</strong></p>
            <ul clas="disc-lists">
                <li>Заявка на перевозку,</li>
                <li>Прочие документы (например MSDS и т.д.)<br />Транспортную накладную (AWB, B/L, CMR, ж/д накладную)</li>
            </ul>
            <p><strong>Для заявок ТО:</strong></p>
            <ul class="disc-lists">
                <li>Контракт</li>
                <li>Дополнительное соглашение</li>
                <li>Спецификация</li>
                <li>Инвойс</li>
                <li>Упаковочный лист</li>
                <li>Техническое описание товара</li>
                <li>SWIFT (п/п об оплате продавцу за товар, если условиями контракта предусмотрен авансовый платеж)</li>
                <li>Экспортная декларация</li>
                <li>Сертификация</li>
                <li>Транспортная накладная (AWB, BL, CMR, ж/д накладная)</li>
                <li>Договор транспортных услуг.</li>
                <li>Счет за транспорт.</li>
                <li>П/п на таможню пошлина.</li>
                <li>П/п на таможню аванс.</li>
                <li>Прайс-лист.</li>
                <li>Страхование.</li>
                <li>Прочие затраты, которые включаются в таможенную стоимость (pick-up до порта/аэропорта/транспортного узла или терминала, ПРР в стране отправления, проведение сюрвейерских проверок, испытание и тестирование оборудования и пр.)</li>
            </ul>
            <b-button class="mt-3 float-right" @click="$bvModal.hide('order-documents-help-modal')">Закрыть</b-button>
        </b-modal>
        <OrderCreateModal @created-order="unshiftNewOrder" />

        <CreateTaskWidget
            :orderId="detailedItem.id"
            @openCreateTaskSidebar="openCreateTaskSidebar"
        />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import {
        API_ORDERS,
        API_ORDERS_BY_SERVICES,
        API_POST_NOTIFICATIONS_READ_BY_SERVICE_REFERENCE_ID,
        API_POST_NOTIFICATIONS_ORDERS_READ,
        API_EMPLOYEES
    } from "@/constants"

    import {
        SERVICE_TO_DOCUMENT
    } from "@/constants"

    import tsoftOrderShowOne from  "@components/orders/OrderShowOne"
    import tsoftOrderServiceDistribution from "@components/orders/OrderServiceDistribution"
    import tsoftCreateCompany from '@components/companies/CreatedOrEditedCompany'
    import tsoftOrderScoring from '@components/orders/OrderScoring'
    import OrderCreateModal from "@components/orders/OrderCreateModal";
    import CreateTaskWidget from '@/components/task/CreateTaskWidget.vue';
    import OrderScoreSidebar from '@/components/orders/OrderScoreSidebar.vue';

    import {
        defaultDataItems,
        actionShowItem,
        actionCreateOrUpdateItem,
        actionDeleteItem,
        actionCopyItem,
        actionScoreItem,
        orderMethods,
        changeCommasOnDots
    } from '@/mixins'
    import { openOrderSidebar } from "@/mixins/openOrderSidebar";
    import { openCreateTaskSidebar } from '@/mixins/openTasksSidebar';


    const initialEditedItem = () => ({
        id: '',
        text_mark: null,
        bitrix_deal_id: null,
        creator_user_id: '',
        creator: {},
        company_employee_id: '',
        company_employee: {
            id: '',
            lead_fio: '',
            lead_email: '',
            lead_phone: '',
        },
        reference_order_type_id: 1,
        type: {},
        company_id: '',
        company: {},
        temp_name: '',
        contacts: {
            lead_fio: "",
            lead_email: "",
            lead_phone: "",
        },
        client: {},
        set_categories_ids: [],             // Virtual for setting up categories
        categories: [],
        set_services_ids: [],               // Virtual for setting up services
        services: [],
        reference_status_id: 359,
        status: {},
        receive_datetime: null,
        processing_end_datetime: null,
        comment: '',
        reference_close_reason_id: '',
        close_reason: {},
        close_comment: '',
        documents: [],
        short_order: false,
        optional_sales_manager_user_id: '',
        optional_sales_manager: {},
        outsourcing_order: 0,
        outsourcing_type_name: 'Нет',
        reference_sources_id: '',
        predictable_mp: null,
        related_orders: [],
    })

    export default {
        mixins: [
            defaultDataItems,
            actionShowItem,
            actionCreateOrUpdateItem,
            actionDeleteItem,
            actionCopyItem,
            actionScoreItem,
            orderMethods,
            changeCommasOnDots,
            openOrderSidebar,
            openCreateTaskSidebar,
        ],
        components: {
            "tsoft-order-show-one": tsoftOrderShowOne,
            "tsoft-order-service-distribution": tsoftOrderServiceDistribution,
            "tsoft-create-company": tsoftCreateCompany,
            "tsoft-order-scoring": tsoftOrderScoring,
            OrderCreateModal,
            CreateTaskWidget,
            OrderScoreSidebar,
        },
        props: {
            companyId: { type: Number | String, required: false, default: '' },         //company id for showing orders
            isTransportCompany: { type: Boolean, default: false },                       //show orders carried by transport company (companyId)
            needFilter: { type: Boolean, default: true },
            specificApiRequest: { type: Object }
        },
        data() {
            return {
                isSideBarOpenCompany: false,
                tableApiUrl: '',
                tableComponentRefreshKey: 0,
                typeOfTableFilter: 'orders',
                editedItemEmployees: {
                    employees: [],
                    loading: false,
                    addNew: false
                },
                editedItemDocumentIdsFromCompany: [],
                openHelp: false,
                headerContextMenuName: 'orderTable',
                tempScoreOrderId: null,
                isSidebarOpenScore: false,
            }
        },

        computed: {
            ...mapGetters("orderDetail", ["orderWidgetValue", "orderChangedColumns", "orderScore"]),
            ...mapGetters("auth", ["currentUser"]),

            isClientAccount() {
                return this.currentUser.role.includes('client');
            },

            isAgent() {
                return this.currentUser.role.includes('agent');
            },

            isLeadObserver() {
                return this.currentUser.role.includes('lead-observer');
            },
        },

        mounted() {
            this.editedItem = initialEditedItem()
        },

        watch: {
            '$route.path'() {
                this.tableApiUrl = this.tableApiUrlChooser()
                this.tableComponentRefreshKey++
            },

            orderWidgetValue(value) {
              let updated_item = this.items.data.filter(item => item.id === value.id)[0]
              updated_item = Object.assign(updated_item, value)
            },

            orderChangedColumns() {
              this.tableComponentRefreshKey += 1
            },

            "editedItem.receive_datetime": function(value) {
                this.editedItem.receive_datetime = value ?
                    this.$moment(value).format('YYYY-MM-DDTHH:mm') :
                    null
            },

            "editedItem.processing_end_datetime": function(value) {
                this.editedItem.processing_end_datetime = value ?
                    this.$moment(value).format('YYYY-MM-DDTHH:mm') :
                    null
            },

            "editedItem.company_id": function(value) {
                this.loadCompanyEmployees(this.editedItem.company_id)
            },

            "editedItem.set_services_ids": function(services_ids) {
                this.editedItemDocumentIdsFromCompany = []

                services_ids.forEach((id, index) => {
                    this.editedItemDocumentIdsFromCompany.push(SERVICE_TO_DOCUMENT[id])
                })
            },

            "editedItem.company_employee.lead_fio": function(inputtedFio) {
                let similarIndex = this.editedItemEmployees.employees.findIndex((employee, index, array) => {
                    if (employee.lead_fio == inputtedFio) {
                        return true
                    }
                    return false
                })

                if (similarIndex != -1) {
                    this.editedItemEmployees.addNew = false
                } else {
                    this.editedItemEmployees.addNew = true
                }
            },

            "editedItem.short_order": function(status) {
                this.editedItem.short_order = (status == 1) ? true : false
            },

            orderScore() {
                if (this.orderScore.id) {
                    let index = this.items.data.findIndex(d => d.id === this.orderScore.order_id);
                    if (index !== -1) {
                        this.items.data[index].order_score = this.orderScore
                    }
                }
            }
        },
        methods: {
            openClientOrderForm() {
              this.$root.$emit("bv::toggle::collapse", "create-order-modal");
            },

            beforeSidebarOpenedCallback() {
              this.$root.$emit("bv::toggle::collapse", "create-order-modal");
            },
            unshiftNewOrder(order) {
              this.items.data.unshift(order)
            },

            tableApiUrlChooser() {
                let apiUrl = API_ORDERS
                this.onDataEmptyMessage = 'Таблица заказов пуста. Создайте новый заказ прямо сейчас.'

                if (this.$route.params.service_id) {
                    apiUrl = `${API_ORDERS_BY_SERVICES}/${this.$route.params.service_id}`
                }

                if (this.tableApiUrl != apiUrl && !this.companyId) {
                    this.tableApiUrl = apiUrl
                    if (this.$route.params.service_id) {
                        this.onDataEmptyMessage = 'Таблица заказов по услуге пуста. Сначала необходимо добавить хотя бы один заказ.'
                        this.typeOfTableFilter = 'order-service'
                        this.clearServiceNotificationList(this.$route.params.service_id)
                    } else {
                        this.typeOfTableFilter = 'order'
                        this.clearOrdersNotificationList()
                    }
                }

                if (this.companyId) {
                    this.tableApiUrl = apiUrl
                }

                return apiUrl
            },

            additionalGetParameter() {
                if (this.companyId && this.isTransportCompany) {
                    return `&only_transport_company_orders=${this.companyId}`
                }

                if (this.companyId) {
                    return `&only_this_company_orders=${this.companyId}`
                }

                return ''
            },

            externalCall() {
                if (this.companyId) {
                    return true
                }

                return false
            },

            clearServiceNotificationList: async function(service_id) {
                const response = await api.call('post', API_POST_NOTIFICATIONS_READ_BY_SERVICE_REFERENCE_ID + `/${service_id}`)
                this.$store.dispatch('GET_NOTIFICATIONS')
            },

            clearOrdersNotificationList: async function(service_id) {
                const response = await api.call('post', API_POST_NOTIFICATIONS_ORDERS_READ, {
                    place: 'left_menu'
                })
                this.$store.dispatch('GET_NOTIFICATIONS')
            },

            createOrderBillFromAction(index) {
                this.showItem(index, '#oneOrderTabs a[href="#order-finance"]')
            },

            createOrderFinanceRequestFromAction(index) {
                this.showItem(index, '#oneOrderTabs a[href="#order-finance-requests"]')
            },

            openOrderDocumentsFromAction(index) {
                this.showItem(index, '#oneOrderTabs a[href="#order-documents"]')
            },

            openServiceDistributionModal(index) {
                this.editIndex = index
                this.editedItem = { ...this.items.data[index] }
                this.isOpenServiceDistributionModal = true
            },

            loadCompanyEmployees(company_id) {
                this.editedItemEmployees.loading = true
                if (company_id) {
                    api.call("get", `${API_EMPLOYEES}/?company_id=${company_id}`).then(({data}) => {
                        this.editedItemEmployees.employees = data.data
                    }).finally(() => {
                        this.editedItemEmployees.loading = false
                    })
                } else {
                    this.editedItemEmployees.loading = false
                }
            },

            // call update one order from action mixin
            updateOneOrder(index, id = -1, data = {}) {
                if (index === -1) {
                    index = this.findElementIndexById(id)
                }
                if (index !== -1) {
                    this.updateOneOrderByIndex(index)
                }
            },

            async makeOrderSupply(index) {
                let id = this.items.data[index].id
                this.items.data[index].loading = true
                let message = await this.finalFormValidate(this.items.data[index])
                const updateFields = {
                    reference_order_type_id: 2,
                    reference_status_id: 359,
                    makingOrderSupply: true,
                }

                if (message.length == 0) {
                    this.updateAnyOrder(id, updateFields, index)
                } else {
                    this.editIndex = index
                    this.openOrderSidebar(id, {edit: false})
                    this.items.data[this.editIndex].loading = false
                    const h = this.$createElement
                    const vNodesMsg = h(
                        'ul',
                        message
                    )
                    this.$bvToast.toast([vNodesMsg], {
                        title: `Невозможно перевести заказ #${id} в Поставку`,
                        variant: 'warning',
                        solid: true,
                        noAutoHide: true
                    })
                }
            },

            setCreatedCompany(data) {
                this.editedItem.company_id = data.id
                this.editedItem.company = data
                this.isSideBarOpenCompany = false
            },

            setClosedSidePanelCompany(){
                this.editedItem = initialEditedItem()
                this.editedItemEmployees.employees = []
                this.editIndex = -1
            },

            changeCreatorUserId(id, data, index) {
                this.dataOverlay = true
                this.updateAnyOrder(id, data, index).then(() => {
                    this.dataOverlay = false
                })
            },

            openScoreSidebar(id) {
                this.tempScoreOrderId = id;
                this.isSidebarOpenScore = true;
            },

            closeScoreSidebar() {
                this.tempScoreOrderId = null;
                this.isSidebarOpenScore = false;
            },

            saveOrderScore(score, text) {
                axios
                    .post('/api/order-scores', {
                        order_id: this.tempScoreOrderId,
                        user_id: this.currentUser.id,
                        score: score,
                        description: text
                    })
                    .then(data => {
                        let index = this.items.data.findIndex(d => d.id === data.data.order_id);
                        if (index !== -1) {
                            this.items.data[index].order_score = data.data
                        }
                        this.closeScoreSidebar()
                    })
                    .catch(er => {
                        console.log(er);
                        this.closeScoreSidebar();
                    })
            },
        }
    }

</script>

<style scoped>
.disc-lists {
    list-style: disc;
    margin-left: 25px;
}
</style>
